// extracted by mini-css-extract-plugin
module.exports = {"root":"_62b5b2","animate":"_d12531","cardGradient":"_3cd72f","title":"_fd4a2f","subTitle":"_f0f188","usersContainer":"_4c35a9"};